import React, { useState } from 'react';
import { Col, Form, Row, Button, Spinner, Alert } from 'react-bootstrap';
import { CommomLoginAunthenticatePost } from './CommonAxios/CommonAxios';
import { CommonPageHeading } from './CommonHeading/CommonPageHeading';

export default function BulkUploadPdf() {
    const [uploadPath, setUploadPath] = useState('DSC_UPLOADS'); // Default path
    const [isUploading, setIsUploading] = useState(false);
    const [jsonOutput, setJsonOutput] = useState([]);

    const handleBulkUpload = async (e) => {
        e.preventDefault();
        const files = Array.from(e.target.files);

        if (files.length === 0) return;

        setIsUploading(true);
        setJsonOutput([]); // Reset previous output

        let baseUrl = 'https://api.apdsc.apcfss.in/dscdms/user-defined-path/file-upload/bucket/documents.apdsc.apcfss.in/';

        // Upload all files in parallel using Promise.all
        const uploadPromises = files.map(async (file) => {
            const formData = new FormData();

            // Keeping the original file directly
            formData.append("file", file);

            // Removing the extension from the file name for the 'name' property
            const nameWithoutExtension = file.name.replace(/\.[^/.]+$/, "");

            try {
                const response = await CommomLoginAunthenticatePost(baseUrl + uploadPath, formData);

                // Assuming response.data gives the URL string based on your existing code
                const uploadedUrl = response?.data;

                return {
                    name: nameWithoutExtension,
                    type: "document",
                    url: uploadedUrl
                };
            } catch (error) {
                console.log("Error at ImageBucket for file:", file.name, error);
                return null; // Return null if this specific file fails
            }
        });

        const allResults = await Promise.all(uploadPromises);

        // Filter out any failed uploads (null values)
        const successfulUploads = allResults.filter(item => item !== null);

        setJsonOutput(successfulUploads);
        setIsUploading(false);
    };

    // Format the output exactly as requested
    const formatGeneratedCode = () => {
        if (jsonOutput.length === 0) return "";

        const objectsString = jsonOutput.map(item => `  {
    name: "${item.name}",
    type: "document",
    url: "${item.url}",
  }`).join(",\n");

        return `[\n${objectsString}\n]`;
    };

    const copyToClipboard = () => {
        navigator.clipboard.writeText(formatGeneratedCode());
        alert("Copied to clipboard!");
    };

    return (
        <React.Fragment>
            <CommonPageHeading heading="Bulk Upload Candidate Documents" />

            <div className="form-section p-4" style={{ backgroundColor: '#fff', borderRadius: '8px' }}>
                <Row className="row mb-4">
                    <Col xxl={4} xl={4} lg={4} md={6} sm={12} xs={12} className="mb-3">
                        <Form.Group controlId="uploadPath">
                            <Form.Label className="input-lable mb-2">Select Upload Path</Form.Label>
                            <Form.Select
                                value={uploadPath}
                                onChange={(e) => setUploadPath(e.target.value)}
                                disabled={isUploading}
                            >
                                <option value="DSC_UPLOADS">DSC_UPLOADS</option>
                                <option value="DSC_PUBLIC_UPLOADS">DSC_PUBLIC_UPLOADS</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>

                    <Col xxl={4} xl={4} lg={4} md={6} sm={12} xs={12} className="mb-3">
                        <Form.Group controlId="bulkFiles">
                            <Form.Label className="input-lable mb-2">Select Multiple PDFs <font color="red">*</font></Form.Label>
                            <div className="d-flex align-items-center">
                                <input
                                    type="file"
                                    multiple
                                    className="form-control"
                                    name="uploadDocBulk"
                                    accept=".pdf"
                                    onChange={handleBulkUpload}
                                    disabled={isUploading}
                                />
                            </div>
                        </Form.Group>
                    </Col>
                </Row>

                {isUploading && (
                    <div className="d-flex align-items-center mb-3">
                        <Spinner animation="border" variant="primary" size="sm" className="me-2" />
                        <span>Uploading files, please wait...</span>
                    </div>
                )}

                {/* OUTPUT SECTION */}
                {!isUploading && jsonOutput.length > 0 && (
                    <Row>
                        <Col sm={12}>
                            <Alert variant="success">Successfully uploaded {jsonOutput.length} files!</Alert>
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <strong>Generated JSON / JS Code:</strong>
                                <Button variant="outline-primary" size="sm" onClick={copyToClipboard}>
                                    Copy Code
                                </Button>
                            </div>
                            <pre style={{
                                backgroundColor: '#282c34',
                                color: '#abb2bf',
                                padding: '15px',
                                borderRadius: '5px',
                                overflowX: 'auto'
                            }}>
                                {formatGeneratedCode()}
                            </pre>
                        </Col>
                    </Row>
                )}
            </div>
        </React.Fragment>
    );
}